import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
import DiagnosisService from "services/DiagnosisService";
import { useDispatch } from "react-redux";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  data: [],
};

export const addDiagnosis = createAsyncThunk(
  "diagnosis/addDiagnosis",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DiagnosisService.addDiagnosis(data);
      if (response.status) {
        console.log(response);

        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getAllDiagnosis = createAsyncThunk(
  "diagnosis/getAllDiagnosis",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DiagnosisService.getAllDiagnosis(data);
      if (response.status) {
        console.log(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateDiagnosis = createAsyncThunk(
  "diagnosis/updateDiagnosis",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DiagnosisService.updateDiagnosis(data);
      if (response.status) {
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DiagnosisSlice = createSlice({
  name: "diagnosis",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addDiagnosis.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(addDiagnosis.fulfilled, (state, action) => {
        state.loading = false;
        // state.data.unshift(action.payload);
        state.message = "Diagnosis Added";
      })
      .addCase(addDiagnosis.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getAllDiagnosis.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(getAllDiagnosis.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.message = "";
      })
      .addCase(getAllDiagnosis.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(updateDiagnosis.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(updateDiagnosis.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.message = "Diagnosis updated successfully!";
      })
      .addCase(updateDiagnosis.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export default DiagnosisSlice.reducer;
